export default {
    activateuser: {
        headerLabel: 'Integração do usuário',
        accountActivation: 'Ativação de conta',
        step1: {
            header: 'Bem-vindo à nossa plataforma! ',
            subHeader: 'Escolha como deseja se conectar à sua conta',
            description:
                'Para um processo de login simplificado, recomendamos que você conecte sua conta a pelo menos um dos seguintes serviços.',
            OR: 'ou',
            emailAndPassword: 'Use seu próprio e-mail',
        },
        step2: {
            header: 'Use e-mail e senha ',
            description:
                'Este é o e-mail principal que será associado à sua conta. Recomendamos que você use um e-mail diferente do endereço vinculado a sua universidade, para manter o acesso aos seus dados após a graduação. Você pode controlar facilmente os e-mails que recebe de nós em suas configurações de conta.',
            invalidEmail: 'O e-mail fornecido não é um e-mail válido.',
            passwordsNotMatch: 'As senhas devem combinar',
            passwordDescription01:
                'Para garantir a segurança da sua conta, você precisa definir uma nova senha. Por favor, crie uma senha com o seguinte:',
            passwordDescription02: 'Mínimo de 8 caracteres',
            passwordDescription03: 'Pelo menos um caractere minúsculo (a-z)',
            passwordDescription04: 'Pelo menos um caractere maiúsculo (A-Z)',
            passwordDescription05: 'Pelo menos um número ou símbolo especial (0-9, !#$ etc)',
            passwordDescription06: 'Ao menos 6 caracteres únicos',
            repeatPassword: 'Repita a senha',
        },
        step3: {
            header: 'Ativando usuário',
            loadingHints: {
                '0': 'Carregando dados do usuário',
                '1': 'Deixando tudo pronto',
                '2': 'Novas possibilidades estão por vir',
                '3': 'Quase pronto!',
            },
            successHeader: 'Sua conta agora está pronta para avançar!',
            successSubheader: 'Agora você pode acessar funcionalidades exclusivas!',
            errorHeader: 'Não foi possível ativar a conta',
            ifWrongContact: 'Se você acha que isso está errado, entre em contato com o suporte',
            contactForHelp: 'Contato para ajuda',
            goBack: 'Volte',
        },
    },
    assessments: {
        general: {
            checkMyProgress: 'Verifique meu progresso',
            getStarted: 'Iniciar! ',
            getToKnowYourself: 'Conheça a si mesmo',
            getToKnowYourselfBold: 'Conheça <strong>yourself</strong>',
            getToKnowYourFuture: 'Conheça o seu futuro',
            getToKnowYourFutureBold: 'Conheça o seu <strong>future</strong>',
            openAssessments: 'Avaliações abertas',
            openAssessment: 'Avaliação aberta ',
            unlock: 'Desbloquear os testes',
            testYourself: 'Teste a si mesmo',
            takeTheFreeTests: 'Faça os testes grátis',
            youOwnThisProduct: 'Você possui este produto',
            startTest: 'Começar o teste',
            startTests: 'Começar os testes',
            continue: 'Prosseguir',
            showReport: 'Mostrar relatório',
            showYourReports: 'Mostrar seus relatórios',
            showYourReport: 'Mostrar seu relatório',
            continueFreeTests: 'Continue os testes grátis',
            continueTheTest: 'Continue o teste',
            estimatedTime: '~ {min} min',
        },
        landing: {
            section1: {
                title: 'Faça Seu Teste',
                description01:
                    'Bem-vindo ao Centro de Avaliações – aqui é onde sua jornada de carreira inicia.',
                description02:
                    'Aqui é onde você pode realizar <strong>Aon Assessments</strong>, testes usados por recrutadores em todo o mundo que verificam sua aptidão e prontidão para a carreira futura.',
                freemium: {
                    description:
                        'Faça estes testes para medir seus pontos fortes e obter relatórios eficientes de suas habilidades.',
                    price: 'Gratuito',
                    numTests: '3 testes',
                    timeEstimated: 'aprox. 27 min',
                },
                premium: {
                    description:
                        'Este é o <strong>real deal</strong>. Faça este teste 3 em 1 para descobrir quais planos de carreira você deve seguir e obtenha um Relatório de Candidato completo.',
                    numTests: 'Teste 3 em 1',
                    timeEstimated: 'aprox. 60 min',
                    sampleReport: '↓Baixar Exemplo de Relatório',
                    candidateReport: 'Relatório de Candidato',
                    candidateReportDescription:
                        'Depois de concluir esses testes, você receberá um Relatório de Candidato completo. O documento inclui uma visão geral dos seus resultados, com dicas para melhorar seu conjunto de habilidades pessoais, quais habilidades você deve prestar atenção, as melhores oportunidades para começar, qual deve ser seu próximo passo e mais.',
                },
            },
            section2: {
                title: 'Como esses testes o ajudarão a ser contratado?',
                t1: 'Você saberá suas <strong>skills</strong>',
                t2: 'Você perceberá o seu <strong>potential</strong>',
                t3: 'Você terá um claro <strong>career path</strong>',
                t4: 'Você irá impulsionar sua <strong>confidence</strong>',
            },
            section3: {
                title:
                    'Aprenda sobre seus próprios pontos fortes e oportunidades de carreira para impulsionar o seu desenvolvimento e progressão profissional.',
            },
            section4: {
                title: 'Saia à frente dos seus concorrentes hoje',
                description:
                    'completando avaliações usadas por recrutadores de todo o mundo em companhias como Deloitte, Siemens, Burger King, Vodafone ou P&G.',
            },
            section5: {
                title: 'Perguntas Frequentes',
                thisPage: 'esta página',
                question01: {
                    q: 'O que são Avaliações Aon?',
                    a:
                        'Avaliações de Talentos da Aon são testes reconhecidos mundialmente que ajudam empresas em todo o mundo a identificarem os melhores candidatos para um emprego. Com a ajuda de avaliações de talentos, os recrutadores podem olhar além de currículos, notas escolares, certificados de faculdade e diplomas universitários para descobrir se um candidato é uma boa opção.\n                <br><br>\n                Essas soluções geralmente são reservadas <strong>for recruiters only</strong> – aqui, você tem a oportunidade<strong>exclusive</strong> de praticar e obter seus resultados antes da entrevista de emprego. A maioria dos candidatos não tem essa chance, então aproveite!',
                },
                question02: {
                    q: 'Preciso pagar para fazer tais avaliações?',
                    a:
                        'Você pode fazer 4 desses testes gratuitamente – <i>Comportamento relacionado ao Trabalho</i>, <i>Raciocínio Numérico</i>, <i>Pensamento Lógico-Dedutivo</i> e <i>Raciocínio Lógico Indutivo</i>. Esses testes medem suas habilidades e aptidão e são uma ótima maneira de descobrir seus pontos fortes e fracos.\n\n                <br><br>No entanto, se quiser ter uma visão geral completa de suas predisposições e dar um grande passo em direção ao sucesso futuro, obtenha insights profissionais sobre os planos de carreira mais adequados acessando o teste 3 em 1 e obtendo um Relatório de Candidato abrangente por € 79. <br><br>Para estender o acesso, apenas <a href={premiumLink}>click here</a> e pague com cartão – nós usamos um método de pagamento seguro.\n                ',
                },
                question03: { q: 'Por que devo fazer esses testes?' },
                question04: {
                    q: 'Como posso me preparar para esses testes?',
                    a:
                        'Você pode ler tudo sobre requerimentos técnicos e como se preparar para as avaliações em <a href={link} target="_blank">this page</a>. Lá você também encontrará materiais que o ajudarão a se superar',
                },
                question05: {
                    q: 'Onde mais posso encontrar essas avaliações?',
                    a:
                        'Normalmente, seu recrutador pode solicitar que você conclua esses testes – além disso, você não os encontrará disponíveis em nenhum outro lugar. É uma oportunidade exclusiva para você praticar, saber mais sobre si mesmo e sobre sua futura carreira.',
                },
                question06: {
                    q: 'Quantas vezes posso fazer os testes?',
                    a:
                        'Você possui apenas uma oportunidade para realizar cada teste. Sem novas tentativas! Certifique-se de que possui condições confortáveis para aproveitar ao máximo esta oportunidade. Você pode se familiarizar com o teste assistindo a vídeos instrutivos screencast (com gravações de tela) e fazendo um exercício prático antes de realizá-lo. ',
                },
                question07: {
                    q: 'Em que idioma os testes estão disponíveis?',
                    a:
                        '\n                O idioma padrão para esses testes é o inglês. No entanto, cada um deles apresenta uma diversidade de idiomas para escolher. Você pode verificar quais idiomas estão disponíveis e selecionar o que melhor se adapta a você antes mesmo de iniciar o teste. \n                ',
                },
                question08: {
                    q:
                        'Existe uma data de expiração nos testes estendidos uma vez que eu pago por eles?',
                    a:
                        'Não! Depois que seu pagamento for aceito, você poderá fazer os testes estendidos sempre que desejar. Reserve um tempo para se preparar e iniciar as avaliações no momento que for melhor para você.',
                },
            },
        },
        center: {
            banner: {
                title: 'Verifique seu progresso',
                subtitle: 'Aqui está uma visão geral do seu progresso nas avaliações de carreira',
                moreInfo: 'Mais informações',
                yourProgress: 'Seu progresso',
                quote: 'Definir metas é o primeiro passo para transformar o invisível em visível.',
            },
            list: {
                timeEstimated: 'aprox. {minutes} min',
                freemium: {
                    intro:
                        '\n                    Este é o primeiro passo da sua jornada de desenvolvimento pessoal! <br />\n                    Faça esses testes para mensurar seus pontos fortes e obter relatórios eficientes das suas\n                    habilidades.\n                ',
                },
                premium: {
                    intro:
                        '\n                    Este é o processo real.<br />\n                    Faça estes testes para descobrir que caminho de carreira você deve seguir e obter um\n                    abrangente <strong>Candidate Report</strong>.\n                ',
                    description:
                        '\n                    Seu <strong>Candidate Report</strong> fornecerá uma visão geral\n                    abrangente dos seus resultados, incluindo <strong>tips</strong> para melhorar seu\n                    conjunto de habilidades pessoais, que <strong>skills</strong> você deve prestar atenção, as\n                    melhores <strong>opportunities</strong> para começar, qual deve ser seu\n                    <strong>next step</strong>, e muito mais.\n                ',
                },
            },
            instruments: {
                '344': {
                    name: 'Pensamento Lógico-Dedutivo',
                    description:
                        'Veja como você é bom no uso do conhecimento e na aplicação de regras – este teste mede suas habilidades analíticas e de resolução de problemas.',
                    estimatedTime: '9',
                },
                '383': {
                    name: 'Raciocínio Lógico Indutivo',
                    description:
                        'Quão bem você consegue identificar as regras e as inter-relações? Verifique com este teste, que mede suas habilidades analíticas e de resolução de problemas.',
                    estimatedTime: '9',
                },
                '390': {
                    name: 'Comportamento Relacionado ao Trabalho',
                    description:
                        'Que tipo de traço de personalidade de funcionário você tem? Descubra fazendo este teste, que identifica suas características de personalidade baseadas no trabalho.',
                    estimatedTime: '30',
                },
                '721': {
                    name: 'Raciocínio Numérico',
                    description:
                        'Você é bom em processar números? Este teste mede sua compreensão das informações numéricas para chegar a conclusões lógicas.',
                    estimatedTime: '9',
                },
                '5392': {
                    name: 'Memória de Trabalho',
                    description:
                        'Quão bem você consegue manter o foco? Este teste mede a capacidade de processar e lembrar informações em ambientes distrativos. ',
                    estimatedTime: '15',
                },
                '82013': {
                    name: 'flexTest',
                    description:
                        'Quais são seus interesses? Este questionário ajudará a determinar quais caminhos de carreira você pode querer seguir.',
                    estimatedTime: '15',
                },
            },
        },
        dialog: {
            header: 'Inicie suas avaliações Aon',
            consent:
                'Eu entendo que a Aon é responsável por meus dados relacionados a esta avaliação e concordo com seus termos e condições.\n                Também concordo que a Highered pode transferir meu nome para a Aon para gerar o meu relatório.',
            startTest: 'Iniciar teste',
            consentErrorTitle: 'Erro de consentimento',
            consentErrorMessage:
                'Algo deu errado ao enviar seu consentimento. Você confirmou seu e-mail?',
        },
    },
    "<br><br>\\n           Premier - vous arrivez préparé avec une partie du processus de recrutement déjà effectuée, ce qui vous fera instantanément prendre de l'avance sur les autres candidats": {
        '\\n            <br><br>\\n Deuxième - vous abordez votre recrutement avec un esprit clair': {
            " Vous connaissez vos points forts et ce que l'avenir vous réserve - motivation instantanée et véritable regain de confiance garantis! Les recruteurs pourront le dire": {
                '"':
                    '\n                Los reclutadores de todo el mundo utilizan las pruebas de evaluación de AON en su proceso de selección de candidatos. Si los completa con antelación y les presenta informes preparados, tendrá una gran oportunidad de sorprender a los reclutadores. ¿Cómo? \n                <br><br>\n                Primero – usted viene preparado con parte del proceso de contratación ya hecho, lo que le hará saltar instantáneamente por delante de otros candidatos.\n                <br><br>\n                Segundo – usted aborda su contratación con una mente clara. Sabe cuáles son sus puntos fuertes y qué le depara el futuro – ¡motivación instantánea y una auténtica inyección de confianza garantizada! Los reclutadores lo notarán.',
            },
        },
    },
    calendar: {
        header: 'Calendário',
        myCalendar: 'Meu Calendário',
        noCalendar: 'Seus serviços de carreira ainda não ativaram a funcionalidade de calendário.',
        goBackBtn: 'Volte',
        calendarNotReady: 'A funcionalidade "meu calendário" ainda não está pronta! Virá em breve',
        noUpcomingAppointments: 'Você não tem compromissos futuros.',
        appointmentMissing: 'Compromisso não ativo',
        appointmentNotActive:
            'Desculpe, você tentou ver um compromisso que não existe ou está inativo.',
        appointmentNotHavingAvailability:
            'Desculpe, este compromisso não está disponível no momento. Verifique novamente mais tarde.',
        appointmentMissingRules: 'Não existe disponibilidade para o agendamento',
        needToCompleteProfile: 'Complete seu perfil',
        noUpcomingAppointmentsPleaseBook: 'Marque um compromisso para desbloquear seu calendário.',
        bookAppointment: 'Marcar compromisso',
        bookAnotherAppointment: 'Marcar um compromisso',
        attendedAppointments: 'Compromissos que você compareceu',
        aboutAppointments: {
            header: 'Sobre compromissos',
            button: 'Sobre ',
            block1: {
                header: 'O que é um compromisso ou agendamento?',
                paragraph1:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                paragraph2:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
            },
            block2: {
                header: 'Quem posso contatar para mais informações?',
                paragraph1:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                paragraph2:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
            },
        },
        bookAnAppointment: 'Marque Um Compromisso ',
        backToCalendarBtn: 'Voltar ao calendário',
        backToBookingBtn: 'Voltar para a lista de compromissos',
        firstAvailable: 'Disponível primeiro',
        loadingAppointment: 'Carregando ...',
        bookModal: {
            title: 'Confirmar reserva',
            with: 'Com',
            confirm: 'Confirmar ',
            continue: 'Prosseguir',
            cancel: 'Fechar',
            first: {
                title: 'Este é o seu primeiro agendamento',
                description:
                    'Para garantir que você receba o convite do evento, por favor confirme que possui o acesso ao calendário pessoal através deste endereço de e-mail ',
                ok: 'OK',
                wrongEmail: 'E-mail incorreto?',
            },
            changeEmail: {
                title: 'Selecione o seu e-mail do calendário',
                inputPlaceholder: 'Digite o e-mail ...',
                ok: 'OK',
                back: 'Use o padrão',
            },
            unknownErrorHeader: 'Ocorreu um erro ao tentar reservar',
            unknownErrorBody:
                'Por favor, tente agendar outro horário. Se não funcionar, contate o suporte.',
            confirmationHeader: 'Seu compromisso está agendado! ',
            bookedTheFollowing: 'Detalhes:',
            emailWillBeSent: 'Um e-mail será enviado para',
            withConfirmation: 'pedindo para você confirmar o comparecimento.',
        },
        dateDetailsModal: { title: 'Compromissos em ' },
        completedYourProfile:
            'Você precisa completar seu perfil para ter acesso ao sistema de calendários',
        toMyProfile: 'Editar meu perfil',
    },
    chat: {
        profileSharingConfirmDialog: {
            title: '{name} quer ver seu perfil',
            content: 'Você deseja compartilhar seu perfil com esta pessoa?',
            share: 'Compartilhar perfil',
            reject: 'Não ',
        },
    },
    companyDetail: {
        locations: {
            header: 'Localizações',
            viewAll: 'Ver tudo ',
            noLocations: 'Sem locais',
            allLocations: 'Todos os locais',
        },
        jobModule: {
            header: 'Top posições',
            viewAllJobs: 'Ver todos os empregos de {companyName}',
            noPositions: '{companyName} atualmente não tem nenhuma posição aberta em Highered.',
            defaultLabel: 'Posições abertas',
        },
        videos: {
            header: 'Vídeos',
            noVideos: 'Sem vídeos',
            noMoreVideos: 'Sem mais vídeos',
            moreVideosFrom: 'Mais vídeos de {companyName}',
        },
        articles: {
            header: 'Artigos',
            noArticles: 'Nenhum artigo',
            noMoreArticles: 'Sem mais artigos',
            moreArticlesFrom: 'Mais artigos de {companyName}',
        },
    },
    components: {
        builders: {
            searchable: { create: 'Criado' },
            yearMonthPicker: { defaultSelect: 'Selecione um mês' },
            localeDropdown: {
                languages: { en: 'Inglês', cn: 'Chinês', fr: 'Francês' },
            },
        },
        miscellaneous: {
            verifyModule: {
                title: 'Verifique seu e-mail escolar',
                description:
                    'É um processo rápido e lhe dará acesso a\n                            funcionalidades exclusivas como anúncios de empregos únicos, testes de habilidades\n                            e recursos de carreira.',
                verificationPending: 'Verificação pendente',
                weHaveSentAnEmail:
                    'Enviamos um e-mail para\n                                <strong>{studentEmail}</strong> for\n                                você se verificar. Tenha certeza de\n                                olhar sua pasta de spam, já que muitas escolas são\n                                bastante estritas com e-mails recebidos. ',
                verifyMe: 'Verifique-me',
                resendVerifyEmail: 'Reenviar e-mail de verificação',
                cancelVerification: 'Cancelar verificação',
                emailSent: 'E-mail enviado',
                emailSentMessage:
                    'E-mail enviado com sucesso. Se você não receber, entre em contato conosco no support@highered.global.',
                resendErrorTitle: 'Erro durante o reenvio de e-mail',
                resendErrorMessage:
                    'Não foi possível reenviar o e-mail de verificação. Por favor, entre em contato com support@highered.global.',
                verificationCancelledTitle: 'Verificação cancelada',
                verificationCancelledMessage: 'Verificação cancelada com sucesso.',
                cancelErrorTitle: 'Erro durante o cancelamento',
                cancelErrorMessage:
                    'Não foi possível cancelar a verificação. Por favor, entre em contato com support@highered.global.',
            },
            verifyModuleDialog: {
                title: 'Verifique seu e-mail escolar',
                university: 'Instituição Acadêmica',
                studentEmail: 'Seu endereço de e-mail acadêmico',
                studentEmailPlaceholder: 'E-mail acadêmico',
                message: 'Mensagem',
                verify: 'Verificar',
                sendRequest: 'Enviar pedido',
                verificationInProcess: 'Verificação em progresso',
                emailHasBeenSentTo:
                    'Um e-mail foi enviado para <strong>{email}</strong>. Siga as instruções para verificar sua conexão com <strong>{schoolName}</strong>',
                verificationRequestSentNonAcademic:
                    'Serviços de carreira da <strong>{schoolName}</strong> precisarão verificar a sua conexão. Você será notificado por e-mail quando isso acontecer. ',
                ifNoEmailRecieved:
                    'Se você não recebeu o e-mail de verificação, por favor, contate-nos. ',
                contactHelp: 'Contate-nos para obter ajuda',
                doNotHaveAcademicEmail: 'Eu não tenho um endereço de e-mail acadêmico',
                doubleCheckEmail:
                    'Por favor, verifique se este endereço de e-mail está correto e se você tem acesso a ele.',
                haveAcademicEmail: 'Eu tenho um endereço de e-mail acadêmico',
                noAcademicEmailInfo:
                    'Se você não usa um endereço de e-mail acadêmico, sua solicitação precisará ser aprovada manualmente pelos serviços de carreira. Portanto, você deve fornecer uma mensagem curta para se identificar.',
                alreadyVerifiedInfo: 'Você já foi verificado nesta escola.',
            },
        },
        navigation: {
            navigation: {
                myPage: 'Minha página',
                jobs: 'Empregos',
                companies: 'Empresas',
                resources: 'Masterclasses',
                assessments: 'Avaliações',
                countryGuides: 'Guias de país',
                goToHaigui: 'Empregos na China',
                signIn: 'Login / Cadastro',
                vfairs: 'Eventos Virtuais',
                events: 'Eventos ',
                newFeature: 'Recurso Novo!',
            },
            profileNavigation: { signOut: 'Sair' },
            sidebar: {
                myPage: 'Minha página',
                myProfile: 'Meu perfil',
                findJobs: 'Encontrar empregos',
                findCompanies: 'Encontrar empresas',
                resources: 'Masterclasses',
                assessments: 'Avaliações',
                countryGuides: 'Guias de país',
                goToHaigui: 'Empregos na China',
                virtualFairs: 'Eventos Virtuais',
                logOut: 'Sair',
            },
            backToCalendar: 'Voltar ao calendário',
            allBooths: 'Todos os estandes',
            home: 'Início',
        },
        smart: {
            companyModule: {
                followJob: 'Adicionar aos favoritos',
                followCompany: 'Seguir empresa',
                unFollowJob: 'Remover dos favoritos',
                unFollowCompany: 'Deixar de seguir a empresa',
                favoritedTitle: 'Salvo nos favoritos',
                favoritedMessage:
                    'Esta posição foi salva em seus favoritos. Encontre as posições favoritas na minha página.',
                unfavoritedTitle: 'Remover dos favoritos',
                unfavoritedMessage: 'Esta posição foi removida dos seus favoritos.',
                favoriteErrorTitle: 'Algo deu errado',
                favoriteErrorMessage: 'Não foi possível favoritar esta posição',
                showAllCompanies: 'Mostrar todas as empresas',
                showOnlyCompaniesLiveOnChat: 'Mostrar apenas empresas ao vivo no chat',
            },
            profileModule: {
                profileCompletion: 'Conclusão do perfil',
                profileCompletionEncouragement:
                    'Mostre-se para os empregadores completando os últimos {percentageLeft} do seu perfil',
                gotoProfilePage: 'Atualizar perfil',
                profileCompleted: 'Perfil completo',
                profileCompletedWhatsNext:
                    'Você sabia que a maioria dos empregadores usa avaliações online em seu processo de recrutamento? Pratique agora e obtenha insights sobre seus pontos fortes e fracos.',
                gotoTestsPage: 'Vá para o centro de avaliação',
                authIndication: {
                    title: 'Encontre o emprego dos seus sonhos',
                    description:
                        'Você quer acesso a cargos que são exclusivos para sua escola e testes que irão alimentar sua busca de emprego? Crie um usuário facilmente com Google, LinkedIn ou Facebook hoje mesmo.',
                    action: 'Vamos lá',
                },
                toProfileHint: 'Para o meu perfil',
                toProfileUncompletedHint:
                    'Seu perfil não está 100% completo. Continue preenchendo para maximizar sua empregabilidade.',
                profileActions: {
                    addFirstName: 'Adicione o primeiro nome',
                    addLastName: 'Adicione sobrenome',
                    addNationality: 'Adicione nacionalidade',
                    addPhoneNumber: 'Adicione seu número de telefone',
                    addLanguage: 'Adicione um idioma',
                    addEducation: 'Adicione educação',
                    addEmail: 'Adicione seu e-mail',
                    addGender: 'Adicione seu gênero',
                },
            },
            featuredCompanies: { label: 'Empresas em Destaque' },
            featuredPositions: { label: 'Posições em Destaque' },
            featuredResource: {
                header: 'Junte-se à Conferência Virtual',
                cta: 'Assista agora!',
                wechatSignupHeader: 'Siga a conta Highered WeChat para obter atualizações',
            },
        },
    },
    '"': 'Quét mã ngay bây giờ!',
    cts: {
        filterNames: {
            employment_types: 'Tipos de emprego',
            education_level: 'Diplomas',
            job_category: 'Áreas',
            address: 'Localizações',
            sector: 'Setores',
            exclude_school_id: 'Excluído',
            languages: 'Idiomas',
        },
        excludeSchoolIds: {
            '-1': 'Postagens compartilhadas',
            unknownSchoolId: 'Parceiro Escolar EFMD',
        },
        educationLevels: {
            BACHELORS_OR_EQUIVALENT: 'Bacharéis',
            MASTERS_OR_EQUIVALENT: 'Mestres',
            DOCTORAL_OR_EQUIVALENT: 'PHD',
            MBA_OR_EQUIVALENT: 'MBA',
            DBA_OR_EQUIVALENT: 'DBA',
        },
        employmentTypes: {
            FULL_TIME: 'Tempo integral',
            INTERN: 'Estágio',
            TEMPORARY: 'Meio período',
            PART_TIME: 'Meio período',
        },
        startDate: 'Início',
        educationFields: {
            ACCOUNTING_AND_FINANCE: 'Contabilidade e finança',
            ADMINISTRATIVE_AND_OFFICE: 'Administrativo e escritório',
            ADVERTISING_AND_MARKETING: 'Publicidade e marketing',
            ART_FASHION_AND_DESIGN: 'Arte, moda e design',
            BUSINESS_OPERATIONS: 'Operações de negócios',
            COMPUTER_AND_IT: 'Computador e TI',
            CUSTOMER_SERVICE: 'Atendimento ao cliente',
            EDUCATION: 'Educação',
            HEALTHCARE: 'Cuidados de saúde',
            HUMAN_RESOURCES: 'Recursos humanos',
            INSTALLATION_MAINTENANCE_AND_REPAIR: 'Manutenção de instalação e reparo',
            LEGAL: 'Jurídico',
            MANAGEMENT: 'Gestão',
            MANUFACTURING_AND_WAREHOUSE: 'Manufatura e armazém',
            MEDIA_COMMUNICATIONS_AND_WRITING: 'Mídias de comunicação e escrita',
            OIL_GAS_AND_MINING: 'Energia',
            PROTECTIVE_SERVICES: 'Serviços de proteção',
            REAL_ESTATE: 'Imobiliária',
            SALES_AND_RETAIL: 'Vendas e varejo',
            SCIENCE_AND_ENGINEERING: 'Ciência e engenharia',
            SOCIAL_SERVICES_AND_NON_PROFIT: 'Serviços sociais e sem fins lucrativos',
            TRANSPORTATION_AND_LOGISTICS: 'Transporte e logística',
        },
        sectors: {
            Consulting: 'Consultoria',
            'Consumer Goods': 'Bens de Consumo',
            'Financial Services / Banking': 'Serviços Financeiros / Bancários',
            'Goverment / Public Administration / Non Profit':
                'Governo / Administração Pública / Sem Fins Lucrativos',
            'International Trade & Development': 'Comércio Internacional & Desenvolvimento',
            Manufacturing: 'Manufatura ',
            'Media / Entertainment': 'Mídia / Entretenimento',
            'Petroleum / Energy': 'Petróleo / Energia',
            'Pharma / Healthcare / Biotech': 'Farmácia / Cuidados de Saúde / Biotecnologia',
            'Real Estate / Construction / Infrastructure':
                'Imobiliária / Construção / Infraestrutura',
            'Technology (IT) / Telecom': 'Tecnologia (TI) / Telecomunicações',
            'Transportations & Logistics': 'Transportes e Logística',
            Other: 'Outro',
        },
        countries: {
            'China (Hong Kong SAR)': 'Hong Kong',
            'Costa Rica': 'Costa Rica',
            'Europe & Sub-Saharan Africa': 'Europa & África Subsaariana',
            'Hong Kong': 'Hong Kong',
            'Korea, South': 'Coreia do Sul',
            'New Zealand': 'Nova Zelândia',
            'Papua-Ny Guinea': 'Papua-Nova Guiné',
            'Puerto Rico': 'Porto Rico',
            'Saudi Arabia': 'Arábia Saudita',
            'South Africa': 'África do Sul',
            'South Korea': 'Coreia do Sul',
            'Sri Lanka': 'Sri Lanka',
            'Taiwan (Province of China)': 'Taiwan',
            'The Seychell Islands': 'Seychelles',
            'United Arab Emirates': 'Emirados Árabes Unidos',
            'United Kingdom': 'Reino Unido',
            'Ivory Coast': 'Costa do Marfim',
            Afghanistan: 'Afeganistão',
            Algeria: 'Argélia',
            Angola: 'Angola',
            Argentina: 'Argentina',
            Armenia: 'Armênia',
            Australia: 'Austrália',
            Austria: 'Áustria',
            Azerbaijan: 'Azerbaijão',
            Bahamas: 'Bahamas',
            Bahrain: 'Bahrein',
            Bangladesh: 'Bangladesh',
            Belarus: 'Bielorrússia',
            Belgium: 'Bélgica',
            Botswana: 'Botsuana',
            Brazil: 'Brasil',
            Bulgaria: 'Bulgária',
            Cambodia: 'Cambodja',
            Canada: 'Canadá',
            Chile: 'Chile',
            China: 'China',
            Colombia: 'Colômbia',
            Congo: 'Congo',
            Croatia: 'Croácia',
            Cyprus: 'Chipre',
            Czechia: 'Tchéquia',
            Denmark: 'Dinamarca',
            Ecuador: 'Equador',
            Egypt: 'Egito',
            Estonia: 'Estônia',
            Ethiopia: 'Etiópia',
            Fiji: 'Fiji',
            Finland: 'Finlândia',
            France: 'França',
            Germany: 'Alemanha',
            Ghana: 'Gana',
            Greece: 'Grécia',
            Guernsey: 'Guernsey',
            Hungary: 'Hungria',
            Iceland: 'Islândia',
            India: 'Índia',
            Indonesia: 'Indonésia',
            Iraq: 'Iraque',
            Ireland: 'Irlanda',
            Israel: 'Israel',
            Italy: 'Itália',
            Japan: 'Japão',
            Jersey: 'Jersey',
            Jordan: 'Jordânia',
            Kazakhstan: 'Cazaquistão',
            Kenya: 'Quênia',
            Kuwait: 'Kuwait',
            Laos: 'Laos',
            Latvia: 'Letônia',
            Lebanon: 'Líbano',
            Lithuania: 'Lituânia',
            Luxembourg: 'Luxemburgo',
            Malaysia: 'Malásia',
            Malta: 'Malta',
            Mauritania: 'Mauritânia',
            Mauritius: 'Ilhas Maurício',
            Mexico: 'México',
            Mongolia: 'Mongólia',
            Morocco: 'Marrocos',
            Myanmar: 'Myanmar',
            Namibia: 'Namíbia',
            Netherlands: 'Países Baixos',
            Nigeria: 'Nigéria',
            Norway: 'Noruega',
            Oman: 'Omã',
            Pakistan: 'Paquistão',
            Panama: 'Panamá',
            Paraguay: 'Paraguai',
            Peru: 'Peru',
            Philippines: 'Filipinas',
            Poland: 'Polônia',
            Portugal: 'Portugal',
            Qatar: 'Catar',
            Romania: 'Romênia',
            Russia: 'Rússia',
            Senegal: 'Senegal',
            Serbia: 'Sérvia',
            Singapore: 'Singapura',
            Slovakia: 'Eslováquia',
            Slovenia: 'Eslovênia',
            Spain: 'Espanha',
            Sudan: 'Sudão',
            Swaziland: 'Suazilândia',
            Sweden: 'Suécia',
            Switzerland: 'Suíça',
            Syria: 'Síria',
            Taiwan: 'Taiwan',
            Tanzania: 'Tanzânia',
            Thailand: 'Tailândia',
            Tonga: 'Tonga',
            Turkey: 'Turquia',
            Ukraina: 'Ucrânia',
            Ukraine: 'Ucrânia',
            USA: 'Estados Unidos (EUA)',
            Uzbekistan: 'Uzbequistão',
            Vanuatu: 'Vanuatu',
            Vietnam: 'Vietnã',
            Zambia: 'Zâmbia',
        },
        languages: {
            Aceh: 'Achém',
            Afrikaans: 'Africâner',
            Albanian: 'Albanês',
            Amharic: 'Amárico',
            Arabic: 'Árabe',
            Arakanese: 'Arracanês',
            Armenian: 'Armênio',
            Azeri: 'Azeri',
            Badini: 'Curmânji',
            Basque: 'Basco',
            Belarusian: 'Bielorrusso',
            Bengali: 'Bengali',
            Berber: 'Berbere',
            Bosnian: 'Bósnio',
            Bulgarian: 'Búlgaro',
            Burmese: 'Birmanês',
            Cantonese: 'Cantonês',
            Catalan: 'Catalão ',
            Cebuano: 'Cebuano',
            Chechen: 'Checheno',
            Chin: 'Hakha Chin',
            Chinese: 'Chinês',
            Croatian: 'Croata',
            Czech: 'Tcheco',
            Danish: 'Dinamarquês',
            Dari: 'Dari',
            Dutch: 'Holandês',
            English: 'Inglês',
            Estonian: 'Estoniano',
            Faroese: 'Feroês',
            Filipino: 'Filipino',
            Finnish: 'Finlandês',
            French: 'Francês',
            German: 'Alemão',
            Greek: 'Grego',
            Greenlandic: 'Groenlandês',
            Hausa: 'Hauçá',
            Hebrew: 'Hebraico',
            Hindi: 'Hindi',
            Hungarian: 'Húngaro',
            Icelandic: 'Islandês',
            Indonesian: 'Indonésio',
            Italian: 'Italiano',
            Japanese: 'Japonês',
            Kazakh: 'Cazaque',
            Kinyarwanda: 'Quiniaruanda',
            Kirundi: 'Kirundi',
            Korean: 'Coreano',
            Kurdish: 'Curdo',
            Kurmanji: 'Curmânji',
            Kven: 'Kven',
            Latin: 'Latim',
            Latvian: 'Letão',
            Lingala: 'Lingala',
            Lithuanian: 'Lituano',
            Macedonian: 'Macedônio',
            Malagasy: 'Malgaxe',
            Malaysian: 'Malaico',
            Mandarin: 'Mandarim',
            Mongolian: 'Mongol',
            Nepali: 'Nepalês',
            Norwegian: 'Norueguês',
            Oromo: 'Oromo',
            Other: 'Outro',
            Panjabi: 'Panjabi',
            Pashto: 'Pachto',
            Persian: 'Persa',
            Polish: 'Polonês',
            Portuguese: 'Português',
            Punjabi: 'Punjabi',
            Romanes: 'Romanês',
            Romani: 'Romani ',
            Romanian: 'Romeno',
            Russian: 'Russo',
            Sami: 'Sámi',
            Serbian: 'Sérvio',
            Sign_language: 'Linguagem de sinais',
            Slovak: 'Eslovaco',
            Slovene: 'Esloveno',
            Somali: 'Somali',
            Sorani: 'Sorâni',
            Spanish: 'Espanhol',
            Swahili: 'Suaíli',
            Swedish: 'Sueco',
            Tagalog: 'Tagalo',
            Tamil: 'Tâmil',
            Thai: 'Tailandês',
            Tigrinya: 'Tigrínia',
            Turkish: 'Turco',
            Ukrainian: 'Ucraniano',
            Urdu: 'Urdu',
            Uyghur: 'Uigur',
            Vietnamese: 'Vietnamita',
            Wolof: 'Uolofe',
        },
    },
    emailverification: {
        headerLabel: 'Verificação de e-mail',
        verifyingEmail: 'Verificando e-mail',
        emailVerifySuccess: 'Seu e-mail foi verificado!',
        emailVerifyFailure: 'Algo deu errado... tente novamente mais tarde ou contate o suporte',
        gotoMyPage: 'Volte para a Minha Página',
    },
    errors: {
        defaultErrorMessage: 'Ocorreu um erro!',
        logInErrorText: {
            invalidCredentials: 'Nome de usuário ou senha incorreta',
            inactiveUser:
                'O usuário com o e-mail fornecido está inativo. Verifique se há ação de ativação da conta em seu e-mail ou tente redefinir sua senha.',
            default: 'Não foi capaz de autenticar.',
        },
        registerErrorText: {
            passwordTooShort: 'A senha deve ter ao menos 8 dígitos.',
            emailAlreadyInUse: 'O e-mail informado já está em uso.',
            emailTaken:
                'O e-mail já está em uso. Se você usou seu e-mail escolar, isso pode ter acontecido porque você já tinha um usuário antes da plataforma ser atualizada (em higheredtalent.org).',
            default: 'Não foi possível criar um usuário.',
        },
        invalidTokenText: { default: 'Seu token é inválido ou já expirou. ' },
        passwordErrorText: {
            passwordTooShort: 'A senha deve ter ao menos 8 dígitos.',
            requireNonAlphanumeric: 'A senha deve conter pelo menos um caractere especial.',
            requireLowerCase: 'A senha deve conter ao menos uma letra minúscula.',
            requireUpperCase: 'A senha deve conter ao menos uma letra maiúscula.',
            requireUniqueChars: 'A senha deve conter pelo menos 6 caracteres diferentes',
            default: 'Não foi possível modificar a senha',
        },
        recoverErrorText: {
            userNotFound: 'O usuário não existe! Por favor, contate o suporte.',
            userAlreadyActive: 'O usuário já está ativado!\nPor favor, tente realizar o login.',
            emailAlreadyInUse:
                'O e-mail fornecido já está em uso.\nSe você deseja prosseguir com a ativação de conta, tente um diferente e-mail ou login social. Caso contrário, vá para a página inicial e entre em sua conta.',
            default: 'Não foi possível ativar a conta.\nPor favor, tente novamente mais tarde.',
        },
        socialAuthErrorText: {
            errorTitle: 'Não foi possível fazer o login com {provider}',
            invalidProviderGoogle:
                'Com o e-mail fornecido, o usuário não está conectado ao Google. Por favor, tente logar com LinkedIn, Facebook, ou e-mail, por exemplo.',
            invalidProviderFacebook:
                'Com o e-mail fornecido, o usuário não está conectado ao Facebook. Por favor, tente logar com Google, LinkedIn, ou e-mail, por exemplo.',
            invalidProviderLinkedIn:
                'Com o e-mail fornecido, o usuário não está conectado ao LinkedIn. Por favor, tente logar com Google, Facebook, ou e-mail, por exemplo.',
            invalidProviderWeChat:
                'Com o e-mail fornecido, o usuário não está conectado ao WeChat. Por favor, tente logar com Google, Facebook, ou e-mail, por exemplo.',
        },
        uniConnErrorText: {
            emailNotAvailable:
                'O e-mail fornecido já está em uso. Isso pode ser porque você já tinha um usuário antes da plataforma ser atualizada (em higheredtalent.org). Por favor, contate o suporte.',
            invalidEmailDomain:
                'Este domínio de e-mail não corresponde à universidade fornecida. Por favor, escolha a universidade correta.',
            existingConnection: 'O usuário já está conectado à universidade fornecida',
            default: 'Não foi possível iniciar a verificação.',
        },
        spotlightErrors: {
            userUpdate: {
                emailAlreadyInUse: 'O e-mail já está em uso',
                default: 'Não foi capaz de atualizar',
            },
        },
    },
    favorites: {
        header: 'Meus favoritos',
        active: 'Ativo',
        expired: 'Expirado',
        expiresThisMonth: 'O prazo de inscrição é este mês',
        expiresThisWeek: 'O prazo de inscrição é esta semana',
        expiresLater: 'O prazo de inscrição é mais tarde',
        noActiveFavorites: 'Você não tem posições favoritas ativas',
        noExpired: 'Você não tem posições favoritas expiradas',
    },
    findcompanies: {
        headerLabel: 'Encontrar empresas',
        companyListLabel: 'Empresas',
    },
    findjobs: {
        header: 'Encontrar empregos',
        changeFilters: 'Mudar filtros',
        recruitmentModule: {
            body:
                'Você administra recrutamentos, é um profissional de carreira ou está apenas\n        interessado em contratar alunos talentosos?',
            createJob: 'Clique aqui para criar um anúncio de emprego',
        },
    },
    general: {
        documentTitle: 'Plataforma de Oportunidades Globais',
        email: 'E-mail',
        password: 'Senha',
        confirmPassword: 'Confirmar senha',
        loading: 'Carregando',
        ok: 'OK',
        save: 'Salvar',
        add: 'Adicionar',
        close: 'Fechar',
        delete: 'Excluir',
        cancel: 'Cancelar',
        done: 'Feito',
        continue: 'Continuar ',
        back: 'Voltar',
        next: 'Próximo',
        finish: 'Finalizar ',
        success: 'Sucesso',
        error: 'Erro',
        description: 'Descrição',
        months: {
            '0': 'Jan',
            '1': 'Fev',
            '2': 'Mar',
            '3': 'Abr',
            '4': 'Maio',
            '5': 'Jun',
            '6': 'Jul',
            '7': 'Ago',
            '8': 'Set',
            '9': 'Out',
            '10': 'Nov',
            '11': 'Dez',
        },
        days: {
            '0': 'Dom',
            '1': 'Seg',
            '2': 'Ter',
            '3': 'Qua',
            '4': 'Qui',
            '5': 'Sex',
            '6': 'Sab',
        },
        dialogs: {
            helperTexts: {
                checkHasPendingAction: 'Checando sua verificação pendente',
                verifySchoolConnection:
                    'Verifique a conexão da sua escola para acessar estes recursos',
                logInToAccessMoreFeatures: 'Milhares de Oportunidades de Carreira Internacional',
            },
        },
        minutesShort: 'min',
        poweredBy: 'Construído por ',
    },
    gptw: {
        company: {
            alt: 'GPTW',
            tooltip: "Esta companhia é certificada como 'Great Place To Work'",
        },
        posting: {
            label: {
                alt: 'GPTW',
                tooltip: "Esta postagem pertence a uma companhia 'Great Place To Work' ",
            },
            detail: {
                alt: 'GPTW',
                tooltip: {
                    isCertified: '{companyName} é certificada como Great Place To Work',
                    description:
                        'Lorem ipsum dolor sit amet, conextetur adipiscing elit. Sed fingilla pretium nunv, non vestibulum tellus imperdiet sed.',
                    readMore: 'Clique para ler mais',
                },
            },
        },
    },
    jobdetail: {
        detailModule: {
            deadline: 'Prazo de inscrição',
            location: 'Localização',
            employmentType: 'Tipo de emprego',
            languageRequirements: 'Requisitos de linguagem',
            workPermitRequirements: 'Requisitos de autorização de trabalho',
            preferredEducationField: 'Campo educacional preferido',
            preferredEducationLevel: 'Nível educacional preferido',
            jobTags: 'Tags',
            apply: 'Inscreva-se agora',
            verificationRequired: 'Você precisa verificar seu e-mail escolar para se inscrever.',
            verificationRequiredHint: 'Você precisa verificar seu e-mail escolar para se inscrever',
            verificationPending: 'Você possui uma verificação pendente nesta escola',
            verificationPendingHint: 'Você possui uma verificação pendente nesta escola',
        },
        invalidJobAd: {
            caption:
                'Desculpe, mas não pudemos encontrar esta posição. Se você achar que isso é um erro, por favor, fale com nosso suporte na janela de chat abaixo.',
            btn: 'Encontrar outros empregos',
        },
    },
    mypage: {
        header: 'Minha página',
        suggestedPositions: 'Posições sugeridas',
        favoriteModule: {
            header: 'Minhas posições favoritas',
            seeAll: 'Ver tudo',
            noFavorites: 'Você não tem posições favoritas ativas',
        },
    },
    recoverpassword: {
        createPassword: 'Crie uma nova senha',
        newPasswordLabel: 'Nova senha',
        newPasswordPlaceholder: 'Senha',
        confirmPasswordLabel: 'Confirmar senha',
        confirmPasswordPlaceholder: 'Confirmar senha ',
        resetPasswordButton: 'Redefinir senha',
        resettingPassword: 'Redefinindo senha',
        passwordsNotMatching: 'As senhas não combinam. ',
    },
    recoveruser: {
        headerLabel: 'Recuperar usuário Highered',
        accountActivation: 'Ativação de conta',
        step1: {
            header: 'Bem-vindo à nossa nova plataforma! ',
            subHeader: 'Escolha como deseja se conectar à sua conta',
            description:
                'Para um processo de login simplificado, recomendamos que você conecte sua conta a pelo menos um dos seguintes serviços.',
            OR: 'ou ',
            emailAndPassword: 'Use seu próprio e-mail',
        },
        step2: {
            header: 'Use e-mail e senha',
            description:
                'Este é o e-mail principal que será associado à sua conta. Recomendamos que você use um e-mail diferente do endereço vinculado a sua universidade, para manter o acesso aos seus dados após a graduação. Você pode controlar facilmente os e-mails que recebe de nós em suas configurações de conta.',
            invalidEmail: 'O e-mail fornecido não é um e-mail válido.',
            passwordsNotMatch: 'As senhas devem combinar',
            passwordDescription01:
                'Para garantir a segurança da sua conta, você precisa definir uma nova senha. Por favor, crie uma senha com o seguinte:',
            passwordDescription02: 'Mínimo de 8 caracteres',
            passwordDescription03: 'Pelo menos um caractere minúsculo (a-z)',
            passwordDescription04: 'Pelo menos um caractere maiúsculo (A-Z)',
            passwordDescription05: 'Pelo menos um número ou símbolo especial (0-9, !#$ etc)',
            passwordDescription06: 'Ao menos 6 caracteres únicos',
            repeatPassword: 'Repita a senha',
        },
        step3: {
            header: 'Ativando o usuário',
            loadingHints: {
                '0': 'Carregando dados do usuário',
                '1': 'Deixando tudo pronto',
                '2': 'Novas possibilidades estão por vir',
                '3': 'Quase pronto! ',
            },
            successHeader: 'Sua conta agora está pronta para avançar!',
            successSubheader: 'Agora você pode acessar novos recursos exclusivos!',
            errorHeader: 'Não foi possível ativar a conta ',
            ifWrongContact: 'Se você acha que algo está errado, por favor, contate o suporte',
            contactForHelp: 'Contato para ajuda',
            goBack: 'Volte',
        },
    },
    resourcesInternal: {
        header: 'Recursos',
        resourceTypeHeader: 'Modelo',
        resourceNoContent: 'Sua escola ainda não ativou a função de recurso.',
        resourceFolderNoContent: 'Não há recursos disponíveis nesta pasta',
        resourceTitleHeader: 'Título',
        resourcePublishDateHeader: 'Publicado',
        searchPlaceholder: 'Procure por nome ou palavra-chave ...',
        cvTemplateHeader: 'MODELO DE CV HIGHERED (ATS-FRIENDLY)',
        cvTemplateSubtitle: 'Baixe aqui! ',
    },
    shared: {
        userNavSection: {
            myPage: 'Minha página',
            myProfile: 'Meu perfil',
            myTests: 'Avaliações',
            myApplications: 'Formulários',
            myFavorites: 'Favoritos',
            internalResources: 'Recursos',
            calendar: 'Calendário',
            documents: 'Upload de CV',
        },
        searchModule: {
            searchBar: { label: 'Procurar por título ou palavras-chave' },
            filters: { clearFilters: 'Limpar filtros' },
            filterLimit: {
                title: 'Limite de filtro atingido',
                message: 'Mais nenhum filtro deste tipo pode ser selecionado',
            },
        },
        postingModule: {
            postingModule: {
                positions: 'Posições ',
                estimatedCount: 'cerca {count} de {totalCount}',
                knownCount: '{count} de {totalCount}',
                noMatchFound: 'Não conseguimos encontrar nada que corresponda aos seus critérios',
            },
            postItem: { applyBefore: 'Prazo de inscrição' },
            postCard: { deadline: 'Prazo final' },
        },
        loginModule: {
            emailVerificationTip: 'Pode demorar alguns minutos para chegar à sua caixa de entrada.',
            noEmail: 'Sem e-mail? Por favor, verifique seu filtro de spam ou:',
            logIn: 'Conecte-se',
            socialAuthBtns: {
                continueWithFacebook: 'Continue com Facebook',
                continueWithGoogle: 'Continue com Google',
                continueWithLinkedIn: 'Continue com LinkedIn',
                continueWithWeChat: 'Continue com WeChat',
            },
            verifyEmail: {
                verifyYourEmail: 'Por favor, verifique seu e-mail',
                weSentAnEmailTo: 'Enviamos uma verificação para',
                continueToSignIn: 'Continue para entrar',
                resendEmail: 'Reenviar link de verificação',
                newEmailSent: 'Novo e-mail enviado',
            },
            registerForm: {
                recommendation:
                    'Recomendamos que você utilize o seu e-mail pessoal e não o\n            e-mail escolar para garantir que terá acesso aos seus dados após a\n            graduação.',
                register: 'Registro',
                passwordsNotMatch: 'As senhas não combinam ',
            },
            logInPaper: {
                useEmail: 'ou use seu e-mail',
                noAccount: 'Não tem uma conta?',
                signUp: 'Inscreva-se',
                logInToAccess: 'Faça login para acessar este recurso',
                showAllOptions: 'Mostrar todas as opções de login',
                hideAllOptions: 'Mostrar menos',
            },
            logInForm: { logIn: 'Login', forgotPassword: 'Esqueceu a senha?' },
            forgotPassword: {
                title: 'Solicitar redefinição de senha ',
                description:
                    'Sem problemas - todo mundo esquece a senha de vez em quando.\n                Digite seu e-mail abaixo para redefinir sua senha',
                resetPassword: 'Redefinir senha',
                emailSentTitle: 'Sua ajuda está a caminho! ',
                emailHasBeenSent:
                    'Um e-mail foi enviado para\n                            <br>\n                            <strong>{email}</strong>\n                            <br>\n                            com instruções sobre como redefinir sua senha. Por favor, verifique sua\n                            caixa de entrada.',
                noEmail: 'Sem e-mail?',
                sendEmailOneMoreTime: 'Enviar e-mail mais uma vez',
                resendErrorTitle: 'Erro durante a recuperação da senha',
                resendErrorMessage:
                    'Não foi possível enviar um e-mail de recuperação de senha. Talvez o e-mail esteja errado?',
            },
        },
        universityBadges: {
            addAnotherUniversity: 'Adicionar outra universidade',
            verificationDialog: {
                verifiedStudent: 'Estudante {schoolAbbr} verificado',
                verificationDescription:
                    'Você é um estudante verificado {schoolAbbr} com e-mail {email}',
                verificationDescriptionNoEmail: 'Você é um estudante {schoolAbbr} verificado',
                checkYourEmail: 'Verifique o seu {schoolAbbr} e-mail.',
                sentEmailDescription:
                    'Enviamos a você um e-mail sobre a verificação de {schoolAbbr} no {email}. Por favor, verifique o seu e-mail.',
                resendEmail: 'Reenviar e-mail',
                cancelVerification: 'Cancelar verificação',
                notYetVerified: 'Afiliação universitária ainda não verificada',
                verifyYourAffiliation:
                    'Para acessar funcionalidades específicas {schoolAbbr}, como anúncios de empregos e recursos exclusivos, verifique sua afiliação.',
                verify: 'Verificar',
                goToPlatform: 'Vá para a plataforma',
                verificationPending: 'Verificação pendente',
                verificationPendingDescription:
                    'Os serviços de carreira na {schoolAbbr} estão verificando sua solicitação. Você será contatado por e-mail quando a verificação for concluída.',
            },
        },
        universityAvatar: {
            dialogs: {
                verificationDialog: {
                    verifiedStudent: 'Estudante {uniSubDomain} verificado',
                    verifiedStudentWithEmail:
                        'Você é um estudante verificado {uniSubDomain} com o e-mail {email}',
                    checkEmail: 'Verifique o seu {uniSubDomain} e-mail.',
                    sentEmailInfo:
                        'Enviamos a você um e-mail sobre a verificação de {uniSubDomain} no {email}. Por favor, verifique seu e-mail. ',
                    resendEmail: 'Reenviar e-mail',
                    cancelVerification: 'Cancelar verificação',
                    notYetVerified: 'Afiliação universitária ainda não verificada.',
                    resourceAccessInfo:
                        'Para acessar {uniSubDomain} recursos específicos, como vagas de emprego e funcionalidades exclusivas, verifique sua afiliação.',
                    verificationCancelled: 'Verificação cancelada',
                    emailSent: 'E-mail enviado',
                },
            },
        },
        termsAndConds: {
            termsAndConditions: 'Termos & Condições',
            privacyPolicy: 'Política de privacidade',
            talentPanel: 'Escola/Empregador?',
        },
        favoriteModule: {
            favoriteCard: {
                deleted: 'Apagado',
                deletedTitle: 'Esta posição não está mais disponível',
            },
        },
        pageNotFound: {
            header: '404',
            description: 'Parece que a página que você está procurando não está mais disponível.',
            goToHome: 'Vá para a página inicial',
            contactus: 'Contate-nos',
        },
        chat: {
            liveNow: 'Ao vivo no chat agora!',
            seeAll: 'Tudo',
            schoolSpecificChats: 'Acesso rápido',
            help: 'Precisa de ajuda?',
            chatExistsLabel: 'Bate-papo existente',
        },
        countdown: {
            day: 'dia',
            days: 'dias',
            hour: 'hora',
            hours: 'horas',
            minute: 'minuto',
            minutes: 'minutos',
            second: 'segundo',
            seconds: 'segundos',
        },
    },
    spotlight: {
        header: 'Meu perfil',
        saveChangesToSubmit: 'Salve seu perfil para que as alterações tenham efeito',
        saveChanges: 'Salvar alterações',
        saveSuccessful: 'Suas alterações foram salvas com sucesso',
        personalDetails: {
            header: 'Detalhes pessoais',
            firstName: 'Nome',
            lastName: 'Sobrenome',
            nationality: 'Nacionalidade',
            gender: 'Gênero sexual',
            uploadProfileImage: 'Upload de foto',
            genderOptions: {
                male: 'Masculino',
                female: 'Feminino',
                other: 'Outro',
                none: 'Prefiro não dizer',
                unknown: 'Desconhecido',
            },
            wrongFileTypeErrorHeader: 'Tipo de arquivo inválido',
            wrongFileTypeErrorDescription: 'Você só pode fazer upload de imagens',
        },
        summary: { header: 'Sumário executivo' },
        contactDetails: {
            header: 'Detalhes de contato',
            contactEmail: 'E-mail de contato',
            phoneNumberHeader: 'Número de celular',
            countryCode: 'Código do país',
            phoneNumber: 'Número de telefone',
            invalidEmail: 'O e-mail digitado não é um e-mail válido. ',
            permanentEmail:
                'NOTA: Esta alteração é permanente. Você só pode definir o seu e-mail uma vez.',
        },
        languages: {
            header: 'Idiomas',
            languageLabel: 'Idioma ',
            levelLabel: 'Nível',
            addLanguage: 'Adicionar novo idioma',
            proficiencies: {
                '22f882cc-3cb0-4cfd-a590-ef010f4d798b': 'Proficiência elementar',
                '82edcac6-693b-42ea-bf24-0a52774f395c': 'Proficiência profissional limitada',
                'a97f6798-7280-4ce7-8896-6d4a8fb58c63': 'Proficiência profissional',
                '93b37709-3f2d-4853-ac77-b8c0dd07243e': 'Proficiência profissional plena',
                '250d296e-d6db-46fb-8c44-07950db80ec4': 'Proficiência nativa ou bilíngue',
            },
        },
        education: {
            header: 'Educação',
            addEducation: 'Adicionar educação',
            notGraduated: 'Ainda não graduado',
            graduatedIn: 'Graduado em {date}',
            dialog: {
                addNewEducation: 'Adicionar nova educação',
                degreeTitle: 'Programa',
                institution: 'Instituição',
                degreeType: 'Diploma',
                fieldOfStudy: 'Área de Estudo',
                cannotFindField: 'Eu não consigo encontrar minha área',
                studyStart: 'Mês de início',
                studyEnd: 'Mês de formatura',
                invalidDegreeTitle: 'Você precisa preencher um título do seu programa.',
                invalidSchool: 'Você precisa selecionar uma escola.',
                invalidStartDate: 'Por favor, selecione uma data de início. ',
                invalidEndDate: 'Por favor, selecione uma data de formatura.',
                invalidStudyPeriod: 'Você não pode se formar antes da data de início.',
                invalidDegreeField: 'Por favor, insira um campo de estudo válido. ',
                invalidDegreeLevel: 'Por favor, selecione um nível válido de seu diploma.',
                selectStartDate: 'Data de início',
                selectEndDate: 'Data de graduação',
                degrees: {
                    '5b468395-7bf7-4f14-88d9-32096884d4ef': 'Bacharel',
                    '09f419fa-1517-41ce-970c-df0d073fc440': 'Mestre',
                    '2c917ed6-5bb7-4e23-95ab-60c55d8df135': 'MBA',
                    '1fff1451-f07c-415c-954a-63b1e5f44fc8': 'DBA',
                    '2fbd6155-d939-40cc-970d-283be0aef433': 'PHD',
                },
                diciplins: {
                    '383c2086-24da-4fe2-977b-7e3d4da85f8e': 'Agricultura & Florestamento',
                    'c8fb1348-bdac-4ed3-af7a-a831376d04b7': 'Ciências Aplicadas & Profissões',
                    '5c665d94-5124-4226-a4f6-da8cca47e3f6': 'Artes, Design & Arquitetura',
                    '06b028e2-d7ed-4281-8668-1009d6da1c35': 'Gestão & Negócios',
                    '747624bb-0174-4961-a3c0-dbe4f1cb750d': 'Ciência da Computação & TI',
                    'ede2bbdb-7a1d-466c-99e5-bcab52e07d69': 'Economia',
                    '5c0432d4-9297-429a-85c4-3305d207764e': 'Educação & Treinamento',
                    '8198b6ea-5b28-4be2-afbc-45df759c65cb': 'Engenharia & Tecnologia',
                    '7e5c0527-d1ec-4125-945e-138ec473e8dd':
                        'Estudos Ambientais & Ciências da Terra',
                    '3babe28b-6285-4a03-b0b8-43f55be393cd': 'Hospitalidade, Lazer & Esportes',
                    '9eebcc51-385e-4122-88a1-6dd3efbaf896': 'Humanidades',
                    '390cf111-b55a-4bb7-a6b6-1cc2b21a248f': 'Jornalismo & Mídia',
                    'a2744908-9521-4330-a07d-3680b058d0a6': 'Lei',
                    '947993e1-b723-4d85-8cd9-a4ae46cd623e': 'Marketing',
                    'c98802c8-74a5-4a98-99ba-84eb76fd1a60': 'Mestre em Inovação e Negócios',
                    'bca263cc-3d17-4ad8-b70e-e2bfe04421fa': 'Mestre em Gestão do Desenvolvimento',
                    'a37667e2-5713-4157-82e9-78c10760d2de': 'Mestre em Ciência de Dados',
                    '72277bb7-9d5e-422a-a2b4-8a8fb8be7143': 'Medicina & Saúde',
                    'bd84a8cd-ce66-4c61-86a8-7fcb6644cc5d': 'MSc em Finanças',
                    '9e665ac9-9611-4508-af4b-22e91f167ea4':
                        'MSc em Estudos de Negócios Internacionais',
                    'baf5bb0a-d0ab-4c13-aacc-c6a8a90e2fcf': 'MSc em Análises de Negócios',
                    '7d832109-642a-4730-aada-26927eb683ee': 'MSc em Gestão',
                    'baf05a5a-faba-4f30-9254-9cd73bb63bbf': 'Matemática & Ciências Naturais',
                    '828cc4ac-1f2b-4133-8e29-ba1347585ae6': 'Ciências Sociais',
                    '44c1f8cf-8696-4638-bc03-9763c2de32af': 'Outro',
                },
            },
        },
        workAuthorization: {
            header: 'Autorização de Trabalho',
            addWorkAuthorization: 'Adicionar autorização de trabalho',
            implicitValue: 'Baseado em sua nacionalidade',
            dialog: {
                selectCountry: 'Selecione o país',
                addEuWorkAuthorization: 'Adicionar autorização de trabalho da UE',
            },
        },
        communication: {
            header: 'Comunicação',
            sendMeUpdatesDescription:
                'Por favor, envie-me notícias sobre carreira, cargos e atualizações da companhia por e-mail',
        },
        errors: {
            imageUpload: {
                title: 'Não foi possível realizar o upload da imagem.',
                message: 'A imagem é muito grande! ',
            },
        },
        exitDialog: {
            title: 'As alterações que não foram salvas serão perdidas',
            message:
                'Você está tentando sair da página sem salvar suas alterações. Você deseja salvar seu perfil antes de prosseguir? ',
            stayAction: 'Fique nesta página',
            saveAction: 'Salvar perfil',
            continueAction: 'Continue sem salvar',
        },
    },
    tests: {
        header: 'Testes',
        unauthorized:
            'Atualmente, os testes estão em beta fechado. Você ainda não tem acesso a estes recursos. Eles estarão disponíveis em breve!',
        error:
            'Algo deu errado ao tentar carregar os testes. Por favor, tente novamente mais tarde.',
        assessmentModule: { header: 'Sua avaliação' },
        completedYourProfile: 'Você precisa completar seu perfil para ter acesso a esta avaliação',
        toMyProfile: 'Editar meu perfil',
    },
    vfair: {
        header: 'Eventos Virtuais EFMD',
        activeNow: 'Em progresso',
        visibilityPrivate: 'Privado',
        visibilityNetwork: 'Rede',
        visibilityOpen: 'Aberto',
        interested: 'Registrar',
        attend: 'Comparecer ao evento',
        enterEvent: 'Entrar no evento virtual',
        notinterested: 'Não estou mais interessado',
        shownInterest: 'Registrado ',
        signUpToday: 'Inscreva-se hoje!',
        vfairsInfo:
            'Conecte-se com empresas e organizações de todo o mundo, em um ambiente sofisticado de simulação de feiras de empregos que permite a interação em tempo real entre recrutadores e candidatos. Clique no evento virtual de seu interesse e inscreva-se para receber as notificações. ',
        recruitingOrgs: 'Organizações & Empresas de Recrutamento',
        preRegistered: 'Pré-registro',
        prepareForTheFair: 'Prepare-se para o evento virtual',
        privateVFairHeader: 'Evento virtual no campus',
        privateVFairMessage:
            'Este evento virtual é hospedado em uma plataforma escolar EFMD e não pode ser acessado daqui.',
        schoolNotJoinedNetworkEventMessage:
            'Sua escola ainda não se inscreveu neste evento virtual, entre em contato com o diretor do programa ou departamento de carreiras e solicite sua participação.  ',
        companyNotJoinedNetworkEventMessage:
            'Sua organização não tem um Estande Virtual ativo neste evento. Entre em contato com Highered para solicitar a participação.  ',
        pavilions: 'Pavilhões',
        general: 'Em geral',
        allCompanies: 'Todas as empresas',
        lobby: 'Salão',
        inviteCode: 'Código de convite',
        eventRequiresInvitation: 'Este evento requer um convite',
        haveCode: 'Eu tenho um código',
        checkCode: 'Verificar código',
        invalidCode: 'Código inválido',
        registeredSuccessfully: 'Registrado com sucesso',
        pavilionTabs: {
            home: 'início',
            companies: 'empresas',
            articles: 'artigos ',
            jobs: 'empregos',
            events: 'eventos ',
        },
        events: {
            noEventsAvailable: 'Nenhum evento disponível',
            showCompleted: 'Mostrar concluídos',
            hideCompleted: 'Esconder concluídos',
            liveNow: 'Ao vivo agora',
            joinTheEvent: 'Junte-se ao evento',
            addToCalendar: 'Adicionar ao calendário',
        },
        links: {
            masterclasses: {
                header: 'Masterclasses',
                buttonCaption: 'Assista às Masterclasses',
                description:
                    'Veja uma grande variedade de masterclasses de alta qualidade, incluindo “Otimização de CV para Ser Contratado”, “Abale Seu Perfil no Linkedin” e “Negociação Salarial”, entre muitos outros, para todas as fases da sua trajetória de carreira! ',
            },
            detailsmasterclass: { header: 'Comparecer à masterclass' },
            cv: {
                header: 'Modelo de CV',
                buttonCaption: 'Download de modelo de CV',
                description:
                    'Acesse o modelo de CV ATS-friendly da Highered para causar uma boa impressão profissional com os recrutadores. ',
            },
            elevatorPitch: {
                header: 'Desafio do Pitch do Elevador',
                buttonCaption: 'Envie seu pitch',
                description:
                    'Aceite o “Desafio do Pitch do Elevador”! Esta é sua oportunidade de apresentar seu valor para centenas de recrutadores das principais empresas e organizações globais! ',
            },
        },
        footerHeaders: {
            social: 'Siga-nos para mais atualizações',
            sponsored: 'Patrocinado por ',
            organized: 'Organizado por',
        },
        educationPopup: {
            step00: {
                header: 'Compartilhe sua educação',
                subtitle: 'Para continuar, deixe os empregadores saberem mais sobre você',
                continueLabel: 'Adicionar minha educação',
                leaveLabel: 'Demissões ',
            },
            step01: { header: 'Conte-nos sobre sua educação' },
            step02: { loadingLabel: 'Só um momento...' },
            step03: {
                header: 'Educação completada',
                subtitle:
                    'Agora você pode compartilhar seu perfil e ficar mais interessante para os empregadores',
                continueLabel: 'Continue explorando o evento virtual',
            },
            error: {
                header: 'Ops! Ocorreu um erro!',
                subtitle:
                    'Não foi possível armazenar sua informação educacional. Por favor, tente novamente mais tarde.',
            },
        },
    },
};
